import React, { Children, cloneElement, useEffect, useRef, useState } from 'react';
import ThreadActionsMenu from './ThreadActionsMenu';

function inlineAction(node) {
    if (!React.isValidElement(node)) return node;
    return cloneElement(node, { role: undefined, ...(typeof node.type !== 'string' ? { menuItem: false } : {}), ...(typeof node.type === 'string' && node.type === 'button' ? { className: 'ia-btn3d ia-comms-pill' } : {}), children: node.props.children ? Children.map(node.props.children, inlineAction) : node.props.children });
}

// Measure the conversation pane, not the browser: a desktop's split pane can
// need exactly the same compact controls as a phone.
export default function ResponsiveThreadActions({ main, children }) {
    const ref = useRef(null);
    const [width, setWidth] = useState(0);
    const actions = Children.toArray(children).filter(Boolean);
    useEffect(() => {
        const pane = ref.current?.closest('[data-thread-header-layout]');
        if (!pane) return undefined;
        const measure = () => setWidth(pane.getBoundingClientRect().width);
        measure();
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(measure); observer.observe(pane);
        return () => observer.disconnect();
    }, []);
    // Keep Take then Note, Flag, Call, Create reservation, Archive. Narrowing
    // progressively moves trailing actions into the same keyboard menu.
    const visible = width >= 1050 ? 5 : width >= 900 ? 4 : width >= 780 ? 3 : width >= 680 ? 2 : width >= 580 ? 1 : 0;
    return <div className="ia-responsive-thread-actions ia-thread-header-bar__actions" ref={ref} data-visible-actions={visible}>
        {main}
        {actions.slice(0, visible).map((node, index) => <span className="ia-thread-inline-action" key={node.key || index}>{inlineAction(node)}</span>)}
        {actions.length > visible && <ThreadActionsMenu>{actions.slice(visible)}</ThreadActionsMenu>}
    </div>;
}
